<div class="page-toolbar">
  <ng-content></ng-content>
</div>
